import { Autocomplete, Button, Grid, IconButton, TextField } from "@mui/material";
import GlobalDialogContent from "../../GlobalDialogContent";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { useDispatch, useSelector } from "react-redux";
import { SewaMasterListService, SewaVolunteerStoreService, SewaVolunteerUpdateService } from "../../../../utils/services/sewa-master.service";
import { showSnackbar } from "../../../../redux/reducer/snackbarSlice";
import { closeDialog } from "../../../../redux/reducer/dialogSlice";
import { setModuleRefresh } from "../../../../redux/reducer/registration/RefreshSlice";
import { Send } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Avatar } from "@mui/material";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";


const AddSewaVolunteer = () => {
    const payload = useSelector((state: any) => state.dialog?.payload);
    const dispatch = useDispatch();
    const [sewaList, setSewaList] = useState<any[]>([])
    const [removedDocs, setRemovedDocs] = useState<number[]>([]);
    const [removedInterestedIds, setRemovedInterestedIds] = useState<number[]>([]);
    const [removedHistoryIds, setRemovedHistoryIds] = useState<number[]>([]);

    const formik = useFormik({
        initialValues: {
            category_name: payload?.category_name || '',
            sewa_category_id: payload?.sewa_category_id || '',
            sewa_name: payload?.sewa_name || '',
            address_or_location: payload?.address_or_location || '',
            description: payload?.description || '',
            sewa_date: payload?.sewa_date || '',
            photos: payload?.documents?.filter((d: any) => d.document_type === "sewa_photo") || [],
            documents: payload?.documents?.filter((d: any) => d.document_type === "additional_document") || [],
            name: payload?.name || '',
            email: payload?.email || '',
            contact: payload?.contact || '',
            education: payload?.education || '',
            profesional_career: payload?.profesional_career || '',
            business_organization: payload?.business_organization || '',
            designation: payload?.designation || '',
            social_attributes: payload?.social_attributes || '',
            roles_assigned: payload?.roles_assigned || '',
            office_address: payload?.office_address || '',
            profile_photo: payload?.profile_photo || null,
            interested_sewas:
                payload?.sewa_interested?.length
                    ? payload.sewa_interested.map((item: any) => ({
                        id: item.id, // ✅ important for delete tracking
                        interested_sewa_id: item.interested_sewa_id,
                        sewa_description: item.sewa_description,
                        support_required: item.support_required,
                    }))
                    : [
                        {
                            interested_sewa_id: "",
                            sewa_description: "",
                            support_required: "",
                        },
                    ],

            sewa_histories:
                payload?.sewa_history?.length
                    ? payload.sewa_history.map((item: any) => ({
                        id: item.id, // ✅ important
                        sewa_id: item.sewa_id,
                        sewa_date: item.sewa_date,
                        description: item.description,
                    }))
                    : [
                        {
                            sewa_id: "",
                            sewa_date: "",
                            description: "",
                        },
                    ],


        },
        validationSchema: Yup.object({
            name: Yup.string().required('Dal Name is Required'),
            education: Yup.string().required('Education is Required'),
            email: Yup.string().email("Invalid email format").required("Email is Required"),
            contact: Yup.string().matches(/^[6-9]\d{9}$/, "Enter valid 10-digit number").required("Mobile Number is Required"),
            profesional_career: Yup.string().required('Professional Career is Required'),
            business_organization: Yup.string().required('Business Organization is Required'),
            designation: Yup.string().required('Designation is Required'),
            office_address: Yup.string().required('Address is Required'),
            social_attributes: Yup.string().required('Social Attributes is Required'),
            profile_photo: Yup.mixed().required('Profile is Required'),
            interested_sewas: Yup.array()
                .min(1, 'At least 1 photo is required')
                .max(5, 'Maximum 5 photos allowed'),

            sewa_histories: Yup.array()
                .min(1, 'At least 1 document is required')
                .max(5, 'Maximum 5 documents allowed'),
        }),
        onSubmit: async (values, { setSubmitting }) => {
            const formData = new FormData();

            formData.append("name", values.name);
            formData.append("email", values.email);
            formData.append("contact", values.contact);
            formData.append("education", values.education);
            formData.append("profesional_career", values.profesional_career);
            formData.append("business_organization", values.business_organization);
            formData.append("designation", values.designation);
            formData.append("office_address", values.office_address);
            formData.append("social_attributes", values.social_attributes);
            formData.append("roles_assigned", values.roles_assigned);

            if (values.profile_photo instanceof File) {
                formData.append("profile_photo", values.profile_photo);
            }

            values.interested_sewas?.forEach((item: any, index: number) => {
                formData.append(`interested_sewas[${index}][interested_sewa_id]`, item.interested_sewa_id);
                formData.append(`interested_sewas[${index}][sewa_description]`, item.sewa_description);
                formData.append(`interested_sewas[${index}][support_required]`, item.support_required);
            });

            values.sewa_histories?.forEach((item: any, index: number) => {
                formData.append(`sewa_histories[${index}][sewa_id]`, item.sewa_id);
                formData.append(`sewa_histories[${index}][sewa_date]`, dayjs(item.sewa_date).format("YYYY-MM-DD"));
                formData.append(`sewa_histories[${index}][description]`, item.description);
            });

            values.documents?.forEach((file: any) => {
                if (file instanceof File) {
                    formData.append("sewa_documents", file);
                }
            });

            removedDocs.forEach((id: any) => {
                formData.append("deleted_document_ids[]", id);
            });

            if (payload?.id) {
                formData.append("id", payload.id);
            }

            if (removedInterestedIds.length > 0) {
                formData.append(
                    "deleted_interested_sewa_ids",
                    JSON.stringify(removedInterestedIds)
                );
            }

            if (removedHistoryIds.length > 0) {
                formData.append(
                    "deleted_sewa_history_ids",
                    JSON.stringify(removedHistoryIds)
                );
            }


            const apiFunction = payload?.id ? SewaVolunteerUpdateService : SewaVolunteerStoreService;
            const { code, message } = await apiFunction(formData);

            if (code === 200) {
                dispatch(showSnackbar({ type: "success", message: message || "Success" }));
                dispatch(closeDialog());
                dispatch(setModuleRefresh({ moduleName: "SewaVolunteerRefresh", refresh: true }));
            } else {
                dispatch(showSnackbar({ type: "error", message: message || "Error" }));
            }
            setSubmitting(false);
        }
    });

    useEffect(() => {
        fetchSewa();
    }, [])

    const fetchSewa = async () => {
        const { code, data } = await SewaMasterListService({});
        if (code === 200 && data?.sewa) {
            setSewaList(data?.sewa);
        } else {
            setSewaList([]);
        }
    }

    const handleDocumentChange = (e: any) => {
        const files = Array.from(e.target.files);
        const allowedTypes = ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",];
        const validFiles = files.filter((file: any) =>
            allowedTypes.includes(file.type)
        );
        const updated = [...formik.values.documents, ...validFiles].slice(0, 5);
        formik.setFieldValue("documents", updated);
    };
    const handleRemoveInterested = (index: number) => {
        const item: any = formik.values.interested_sewas[index];

        if (item?.id) {
            setRemovedInterestedIds((prev) => [...prev, item.id]);
        }

        const updated = [...formik.values.interested_sewas];
        updated.splice(index, 1);

        formik.setFieldValue("interested_sewas", updated);
    };

    const handleRemoveHistory = (index: number) => {
        const item: any = formik.values.sewa_histories[index];

        if (item?.id) {
            setRemovedHistoryIds((prev) => [...prev, item.id]);
        }

        const updated = [...formik.values.sewa_histories];
        updated.splice(index, 1);

        formik.setFieldValue("sewa_histories", updated);
    };


    const handleRemoveDocument = (index: number) => {
        const file = formik.values.documents[index];

        if (!(file instanceof File)) {
            setRemovedDocs((prev) => [...prev, file.document_id]);
        }

        const updated = [...formik.values.documents];
        updated.splice(index, 1);
        formik.setFieldValue("documents", updated);
    };


    return (
        <form onSubmit={formik.handleSubmit}>
            <GlobalDialogContent
                dialogBody={
                    <Grid container spacing={2}>
                        <Grid item xs={12} display="flex" flexDirection="column" alignItems="center" >
                            <Avatar
                                src={
                                    formik.values.profile_photo instanceof File
                                        ? URL.createObjectURL(formik.values.profile_photo)
                                        : formik.values.profile_photo
                                            ? `${process.env.REACT_APP_CDN_URL}/${formik.values.profile_photo}`
                                            : ""
                                }
                                sx={{
                                    width: 50,
                                    height: 50,
                                    mb: 1,
                                    fontSize: 40
                                }}
                            />
                            <Button
                                variant="outlined"
                                component="label"
                                startIcon={<AddAPhotoIcon />}
                            >
                                {formik.values.profile_photo ? "Change Photo" : "Upload Photo"}
                                <input
                                    type="file"
                                    hidden
                                    accept="image/*"
                                    onChange={(e: any) =>
                                        formik.setFieldValue("profile_photo", e.target.files[0])
                                    }
                                />
                            </Button>
                            {formik.touched.profile_photo && formik.errors.profile_photo && (
                                <div style={{ color: "red", marginTop: 5 }}>
                                    {formik.errors.profile_photo as string}
                                </div>
                            )}
                        </Grid>
                        <Grid item xs={4} >
                            <TextField
                                fullWidth
                                label="Name of Volunteer *"
                                name="name"
                                size="small"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                placeholder="Enter Volunteer Name"
                                error={formik.touched.name && Boolean(formik.errors.name)}
                                helperText={formik.touched.name && Boolean(formik.errors.name)}
                            />
                        </Grid>
                        <Grid item xs={4} md={4}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Email *"
                                name="email"
                                type="email"
                                value={formik.values.email}
                                onChange={(e) => {
                                    formik.setFieldValue('email', e.target.value.toLowerCase());
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && Boolean(formik.errors.email)}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Mobile Number *"
                                name="contact"
                                type="text"
                                inputProps={{
                                    maxLength: 10,
                                    pattern: "[0-9]*",
                                    inputMode: "numeric",
                                }}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                        formik.setFieldValue("contact", value);
                                    }
                                }}
                                value={formik.values.contact}
                                onBlur={formik.handleBlur}
                                error={formik.touched.contact && Boolean(formik.errors.contact)}
                                helperText={formik.touched.contact && Boolean(formik.errors.contact)}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label="Education *"
                                name="education"
                                size="small"
                                value={formik.values.education}
                                onChange={formik.handleChange}
                                placeholder="Enter Education"
                                error={formik.touched.education && Boolean(formik.errors.education)}
                                helperText={formik.touched.education && Boolean(formik.errors.education)}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label="Professional Career *"
                                name="profesional_career"
                                size="small"
                                value={formik.values.profesional_career}
                                onChange={formik.handleChange}
                                placeholder="Enter Professional Career"
                                error={formik.touched.profesional_career && Boolean(formik.errors.profesional_career)}
                                helperText={formik.touched.profesional_career && Boolean(formik.errors.profesional_career)}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label="Business Organization *"
                                name="business_organization"
                                size="small"
                                value={formik.values.business_organization}
                                onChange={formik.handleChange}
                                placeholder="Enter Business Organization"
                                error={formik.touched.business_organization && Boolean(formik.errors.business_organization)}
                                helperText={formik.touched.business_organization && Boolean(formik.errors.business_organization)}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label="Designation *"
                                name="designation"
                                size="small"
                                value={formik.values.designation}
                                onChange={formik.handleChange}
                                placeholder="Enter Designation"
                                error={formik.touched.designation && Boolean(formik.errors.designation)}
                                helperText={formik.touched.designation && Boolean(formik.errors.designation)}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label="Social Attributes *"
                                name="social_attributes"
                                size="small"
                                value={formik.values.social_attributes}
                                onChange={formik.handleChange}
                                placeholder="Enter Social Attributes"
                                error={formik.touched.social_attributes && Boolean(formik.errors.social_attributes)}
                                helperText={formik.touched.social_attributes && Boolean(formik.errors.social_attributes)}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label="Roles Assigned *"
                                name="roles_assigned"
                                size="small"
                                value={formik.values.roles_assigned}
                                onChange={formik.handleChange}
                                placeholder="Enter Roles Assigned"
                                error={formik.touched.roles_assigned && Boolean(formik.errors.roles_assigned)}
                                helperText={formik.touched.roles_assigned && Boolean(formik.errors.roles_assigned)}
                            />
                        </Grid>


                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Office Address*"
                                name="office_address"
                                size="small"
                                value={formik.values.office_address}
                                onChange={formik.handleChange}
                                placeholder="Enter History of Sewa"
                                error={formik.touched.office_address && Boolean(formik.errors.office_address)}
                                helperText={formik.touched.office_address && Boolean(formik.errors.office_address)}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <label style={{fontWeight: 600}}>Interested Sewas *</label>
                            {formik.values.interested_sewas.map((item: any, index: number) => (
                                <Grid container spacing={1} key={index} alignItems="center" mt={1}>
                                    <Grid item xs={3}>
                                        <Autocomplete
                                            options={sewaList}
                                            getOptionLabel={(option) => option?.sewa_name || ""}
                                            value={
                                                sewaList.find(
                                                    (s) => s.id === item.interested_sewa_id
                                                ) || null
                                            }
                                            onChange={(e, value) => {
                                                formik.setFieldValue(
                                                    `interested_sewas[${index}].interested_sewa_id`,
                                                    value?.id || ""
                                                );
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} size="small" label="Select Sewa" />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Support Required"
                                            value={item.support_required}
                                            onChange={(e) =>
                                                formik.setFieldValue(
                                                    `interested_sewas[${index}].support_required`,
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Description"
                                            value={item.sewa_description}
                                            onChange={(e) =>
                                                formik.setFieldValue(
                                                    `interested_sewas[${index}].sewa_description`,
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </Grid>

                                    <Grid item xs={1}>
                                        <IconButton
                                            color="error"
                                            onClick={() => {
                                                const updated = [...formik.values.interested_sewas];
                                                updated.splice(index, 1);
                                                formik.setFieldValue("interested_sewas", updated);
                                                if (item?.id) {
                                                    handleRemoveInterested(item)
                                                }
                                            }}
                                        >
                                            <HighlightOffIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            ))}
                            <Grid item sx={{ textAlign: 'center' }}>
                                {formik.values.interested_sewas.length < 5 && (
                                    <Button variant="outlined" sx={{ mt: 1 }}
                                        startIcon={<AddCircleOutlineIcon />}
                                        onClick={() =>
                                            formik.setFieldValue("interested_sewas", [
                                                ...formik.values.interested_sewas,
                                                {
                                                    interested_sewa_id: "",
                                                    sewa_description: "",
                                                    support_required: "",
                                                },
                                            ])
                                        }
                                    >
                                        Add Row
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <label style={{fontWeight: 600}}>Sewa Histories *</label>
                            {formik.values.sewa_histories.map((item: any, index: number) => (
                                <Grid container spacing={1} key={index} alignItems="center" mt={1}>
                                    <Grid item xs={3}>
                                        <Autocomplete
                                            options={sewaList}
                                            getOptionLabel={(option) => option?.sewa_name || ""}
                                            value={
                                                sewaList.find((s) => s.id === item.sewa_id) || null
                                            }
                                            onChange={(e, value) => {
                                                formik.setFieldValue(
                                                    `sewa_histories[${index}].sewa_id`,
                                                    value?.id || ""
                                                );
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} size="small" label="Select Sewa" />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={3}>
                                        <DatePicker
                                            value={item.sewa_date ? dayjs(item.sewa_date) : null}
                                            onChange={(value) =>
                                                formik.setFieldValue(
                                                    `sewa_histories[${index}].sewa_date`,
                                                    value ? value.toDate() : ""
                                                )
                                            }
                                            sx={{ ".MuiButtonBase-root": { marginRight: 0 } }}
                                            maxDate={dayjs()}
                                            format="DD-MM-YYYY"
                                            slotProps={{
                                                textField: {
                                                    size: "small",
                                                    fullWidth: true,
                                                    label: "Sewa Date",
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={5}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Description"
                                            value={item.description}
                                            onChange={(e) =>
                                                formik.setFieldValue(
                                                    `sewa_histories[${index}].description`,
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </Grid>

                                    <Grid item xs={1}>
                                        <IconButton
                                            color="error"
                                            onClick={() => {
                                                const updated = [...formik.values.sewa_histories];
                                                updated.splice(index, 1);
                                                formik.setFieldValue("sewa_histories", updated);
                                                if (item?.id) {
                                                    handleRemoveHistory(item)
                                                }
                                            }}
                                        >
                                            <HighlightOffIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            ))}
                            <Grid item sx={{ textAlign: 'center' }}>
                                {formik.values.sewa_histories.length < 5 && (
                                    <Button
                                        variant="outlined" sx={{ mt: 1 }}
                                        startIcon={<AddCircleOutlineIcon />}
                                        onClick={() =>
                                            formik.setFieldValue("sewa_histories", [
                                                ...formik.values.sewa_histories,
                                                {
                                                    sewa_id: "",
                                                    sewa_date: "",
                                                    description: "",
                                                },
                                            ])
                                        }
                                    >
                                        Add History
                                    </Button>
                                )}
                            </Grid>
                        </Grid>


                        <Grid item xs={12}>
                            <label style={{fontWeight: 600}}>Sewa Documents *</label>
                            <Grid container spacing={1} mt={1}>
                                {formik.values.documents?.map((file: any, index: number) => (
                                    <Grid item key={index}>
                                        <div style={{ position: "relative", border: '1px solid #ffcdcd', borderRadius: '6px' }}>
                                            <Button variant="text">
                                                <TextSnippetIcon sx={{ mr: 1 }} />
                                                {file instanceof File
                                                    ? file.name
                                                    : file.document_path.split("/").pop()}
                                            </Button>

                                            <HighlightOffIcon onClick={() => handleRemoveDocument(index)} style={{ position: "absolute", top: -8, right: -8, cursor: "pointer", borderRadius: "50%", fontSize: 18 }} color="error" />
                                        </div>
                                    </Grid>
                                ))}

                                {formik.values.documents?.length < 5 && (
                                    <Grid item>
                                        <Button variant="text" component="label">
                                            <AddCircleOutlineIcon />
                                            <input
                                                type="file"
                                                hidden
                                                multiple
                                                onChange={handleDocumentChange}
                                                accept=".pdf,.xlsx"
                                            />
                                        </Button>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>


                    </Grid>
                }
                dialogFooter={
                    <Button type="submit" disabled={formik.isSubmitting || !formik.isValid} variant="contained" color="primary" startIcon={<Send />} >
                        {formik.isSubmitting ? payload?.id ? "Updating..." : "Adding..." : payload?.id ? "Update Sewa Volunteer" : "Add Sewa Volunteer"}
                    </Button>
                }
            />
        </form>
    )
}

export default AddSewaVolunteer;